import { NBH_SEARCH } from "../../actionTypes/actionsTypes";
import { ActionPayload, AppAction, BaseAsyncReducerState } from "../../types";

export interface Centroid {
    lat: number,
    lon: number
}

export interface ResultObject {
    address:    string,
    city: string,
    centroid: Centroid,
    roll: string,
    noCentroid?: boolean
}


export interface SearchResponse extends BaseAsyncReducerState {
    results: Array<ResultObject> | [];
    pages: number;
    page: number
}

// Define an initial state value for the app
const initialState: SearchResponse = {
    loading: false,
    error: false,
    results: [],
    pages: 1,
    page: 1
}

function FullSearchReducer(state = initialState, action: AppAction) {
    // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case NBH_SEARCH.PENDING:
            return {
                ...state,
                loading: true,
                error: false
            }
        case NBH_SEARCH.SUCCESS:
            return {
                ...state,
                ...payload as ActionPayload ,
                loading: false,
                error: false

            }
        case NBH_SEARCH.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        case NBH_SEARCH.RESET:
            return {
                ...state,
                ...initialState,
            };
        default:
            return state
    }
}

export default FullSearchReducer;